<template>
  <entity-list-table
    :title="title"
    :data-service="dataService"
    :headers="headers"
    :create-route-name="createRouteName"
    :edit-route-name="editRouteName"
    allow-delete
    :show-status-column="false"
  >
  </entity-list-table>
</template>

<script>
  import EntityListTable from '@/components/ui/crud/EntityListTable.vue'
  import SourceDataService from '@/services/api/SourceDataService'

  export default {
    components: { EntityListTable },
    data () {
      return {
        title: 'Источники',
        dataService: SourceDataService,
        createRouteName: 'source-create',
        editRouteName: 'source-edit',

        headers: [
          { text: 'ID', value: 'id', align: 'center' },
          { text: 'Название', value: 'name', align: 'start' },
          { text: 'Аббревиатура', value: 'abbreviation', align: 'center' },
          {
            text: 'Обязателен для всех филиалов',
            value: 'requiredForAllFilials',
            align: 'center',
            type: 'boolean-check',
          },
        ],
      }
    },
  }
</script>
